import { AxiosResponse } from 'axios'
import { BaseTableRequest, EOp, Medicine, RequestById, TableResponse } from 'types'
import axiosInstance from './axios'

export const getMedicine = (id: number) => {
  return axiosInstance.post<void, TableResponse<Medicine>>('/medicine', {
    filter: {
      carePersonId: {
        type: 'number',
        op: EOp.equals,
        value: id,
      },
    },
  } satisfies BaseTableRequest)
}

export const createMedicine = (contact: Partial<Medicine>) => {
  return axiosInstance.post<void, AxiosResponse<void>>('/medicine/create', contact)
}

export const updateMedicine = (medicine: Partial<Medicine> & { id: number }) => {
  return axiosInstance.post<void, AxiosResponse<void>>('/medicine/update', medicine)
}

export const deleteMedicine = (request: RequestById) => {
  return axiosInstance.post<void, AxiosResponse<void>>('/medicine/delete', request)
}
